// extracted by mini-css-extract-plugin
export default {"container":"index_container_mjUWL","recNews":"index_recNews_xApRk"};